import React, { useState } from "react";
import Nav from "react-bootstrap/Nav";
import { Modal, Row, Col, Container } from "react-bootstrap";
import { Link } from "@mui/material";
import ShowAlert from "./alert.jsx";
import SwaranandhraService from "../Services/SwaranandhraService.jsx";
import ListGroup from "react-bootstrap/ListGroup";
import Menubar from "./Menubar.jsx";
export default function Dashboard() {
  let roleid = localStorage.getItem("role");
  let distid = localStorage.getItem("districtid");
  let mandalid = localStorage.getItem("mandalid");
  let userid = localStorage.getItem("username");

  let pending_at_ad = localStorage.getItem("pending_at_ad");
  let pending_at_aso = localStorage.getItem("pending_at_aso");
  let mandal_total_count = localStorage.getItem("mandal_total_count");
  let pending_at_cpo = localStorage.getItem("pending_at_cpo");
  let approved = localStorage.getItem("approved");
  let to_bestart_aso_t_a = localStorage.getItem("to_bestart_aso_t_a");

  let aso_pending_at_ad = localStorage.getItem("aso_pending_at_ad");
  let aso_pending_at_aso = localStorage.getItem("aso_pending_at_aso");
  let aso_pending_at_cpo = localStorage.getItem("aso_pending_at_cpo");
  let aso_approved = localStorage.getItem("aso_approved");
  let aso_to_bestart_aso_t_a = localStorage.getItem("aso_to_bestart_aso_t_a");

  const [addModal, setAddModal] = useState();
  const [addModal2, setAddModal2] = useState();
  const [dataentry, setdataentry] = useState(false);
  const [gmdp, setgmdp] = useState(false);

  const handleClose = () => {
    setAddModal(false);
  };

  const handleClose2 = () => {
    setAddModal2(false);
  };

  const [asodata, setasodata] = useState();
  const [totalmandals, settotalmandals] = useState(false);
  const [cpodata, setcpoodata] = useState(false);
  const [addata, setaddata] = useState(false);
  const [Approvedata, setApprovedata] = useState(false);
  const [aso_asodata, setAso_asodata] = useState();
  const [aso_cpodata, setAso_cpodata] = useState();
  const [aso_addata, setAso_addata] = useState();
  const [aso_Approvedata, setAso_Approvedata] = useState();
  const [tobestartdata, settobestartdata] = useState(false);
  const [asotobestartdata, setasotobestartdata] = useState(false);

  const handleStatusResponse = (
    response,
    type,
    setDataFunctions,
    setStateFunction
  ) => {
    if (response.data.SCODE === "01") {
      Object.values(setDataFunctions).forEach((fn) => fn(false));

      if (setStateFunction[type]) {
        setStateFunction[type](true);
      }

      setAddModal(true);
      setmandaldata(response.data.SDESC);
    } else {
      ShowAlert(response.data.SDESC, "error");
    }
  };

  const handleStatusData = (type) => {
    let params = {
      userId: userid,
      type: type,
      district_id: distid,
    };

    SwaranandhraService.status_list(params).then((response) => {
      handleStatusResponse(
        response,
        type,
        {
          settotalmandals,
          setasodata,
          setcpoodata,
          setaddata,
          setApprovedata,
          settobestartdata,
        },
        {
          allMandalsAtAdOrCpo: settotalmandals,
          yetToBeStartedAtAdOrCpo: settobestartdata,
          pendinglistAtAso: setasodata,
          pendinglistAtCpo: setcpoodata,
          pendinglistAtAd: setaddata,
          approvedListAtAdOrCpo: setApprovedata,
        }
      );
    });
  };

  const handleStatusData2 = (type) => {
    let params = {
      userId: userid,
      type: type,
      district_id: distid,
      service_type: "1",
      mandal_id: mandalid,
    };

    SwaranandhraService.status_list(params).then((response) => {
      handleStatusResponse(
        response,
        type,
        {
          setAso_asodata,
          setAso_cpodata,
          setAso_addata,
          setAso_Approvedata,
          setasotobestartdata,
        },
        {
          yetToBeStartedAtAso: setasotobestartdata,
          pendinglistAtAso: setAso_asodata,
          pendinglistAtCpo: setAso_cpodata,
          pendinglistAtAd: setAso_addata,
          approvedListAtAso: setAso_Approvedata,
        }
      );
    });
  };

  const [data, setdata] = useState([]);
  const [data1, setdata1] = useState([]);
  const [mandaldata, setmandaldata] = useState([]);

  const dataentrytargetdata = (id) => {
    let params = {
      userId: userid,
      district_id: distid,
      mandal_id: id,
    };
    SwaranandhraService.dataEntryForTargets(params).then((response) => {
      if (response.data.SCODE === "01") {
        setAddModal(false);
        setAddModal2(true);
        setdataentry(true);
        setgmdp(false);
        setdata(response.data.SDESC);
      } else {
        ShowAlert(response.data.SDESC, "error");
      }
    });

    SwaranandhraService.gmdpContributions(params).then((response) => {
      if (response.data.SCODE === "01") {
        setdata1(response.data.SDESC);
      } else {
        ShowAlert(response.data.SDESC, "error");
      }
    });
  };

  return (
    <>
    <Menubar />
      {(roleid === "3" || roleid === "2" || roleid === "10") ? (
        <Container fluid>
          <Row>
            <div className="sa-title">
              <h2>
                Dashboard <span>Status</span>
              </h2>
            </div>
          </Row>

          <Row className="mb-4">
            {(roleid === "2" || roleid === "10") && (
              <Col
                xxl={2}
                xl={2}
                lg={2}
                md={6}
                sm={6}
                xs={6}
                className="mb-3"
              >
                <div className="sa-card sa-card22">
                  <div className="d-flex justify-content-between">
                    <div className="head">
                      No.Of <span>Mandals</span>
                    </div>
                    <div>
                      <img src="../images/control.webp" alt="control"/>
                    </div>
                  </div>
                  <div className="d-flex">
                    <div className="w-100">
                      <b className="w-100">
                        {" "}
                        <span
  role="button"
  tabIndex={mandal_total_count !== "0" && mandal_total_count ? 0 : -1}
  style={{
    marginTop: "10px",
    cursor:
      mandal_total_count === "0" || !mandal_total_count
        ? "default"
        : "pointer",
  }}
  onMouseEnter={(e) => {
    if (mandal_total_count !== "0") e.currentTarget.style.color = "blue";
  }}
  onMouseLeave={(e) => {
    if (mandal_total_count !== "0") e.currentTarget.style.color = "black";
  }}
  onClick={() => {
    if (mandal_total_count !== "0") {
      handleStatusData("allMandalsAtAdOrCpo");
    }
  }}
  onKeyDown={(e) => {
    if (
      mandal_total_count !== "0" &&
      mandal_total_count &&
      (e.key === "Enter" || e.key === " ")
    ) {
      handleStatusData("allMandalsAtAdOrCpo");
    }
  }}
>{" "}
  {mandal_total_count === undefined ? "" : mandal_total_count || 0}
 </span>

                      </b>
                    </div>
                  </div>
                </div>
              </Col>
            )}
            <Col
              xxl={2}
              xl={2}
              lg={2}
              md={6}
              sm={6}
              xs={6}
              className="mb-3"
            >
              <div className="sa-card sa-card11">
                <div className="d-flex justify-content-between">
                  <div className="head">
                    Yet To Be <span>Started</span>
                  </div>
                  <div>
                    <img src="../images/shuttle.webp" alt="shuttle"/>
                  </div>
                </div>
                <div className="d-flex">
                  <div className="w-100">
                    {(roleid === "2" || roleid === "10") && (
                      <b className="w-100">
                        {" "}
                        <span
  role="button"
  tabIndex={0}
  style={{
    cursor:
      to_bestart_aso_t_a === "0" || !to_bestart_aso_t_a
        ? "default"
        : "pointer",
  }}
  {...(to_bestart_aso_t_a !== "0" &&
    to_bestart_aso_t_a && {
      onMouseEnter: (e) => (e.currentTarget.style.color = "blue"),
      onMouseLeave: (e) => (e.currentTarget.style.color = "black"),
    })}
  onClick={() => {
    if (to_bestart_aso_t_a !== "0") {
      handleStatusData("yetToBeStartedAtAdOrCpo");
    }
  }}
  onKeyDown={(e) => {
    if (e.key === "Enter" || e.key === " ") {
      if (to_bestart_aso_t_a !== "0") {
        handleStatusData("yetToBeStartedAtAdOrCpo");
      }
    }
  }}
>
  {" "}
  {to_bestart_aso_t_a === undefined ? "" : to_bestart_aso_t_a || 0}
</span>

                      </b>
                    )}

                    {roleid === "3" && (
                      <b className="w-100">
                        {" "}
                        <span
  role="button"
  tabIndex={0}
  style={{
    cursor:
      aso_to_bestart_aso_t_a === "0" || !aso_to_bestart_aso_t_a
        ? "default"
        : "pointer",
  }}
  {...(aso_to_bestart_aso_t_a !== "0" &&
    aso_to_bestart_aso_t_a && {
      onMouseEnter: (e) => (e.currentTarget.style.color = "blue"),
      onMouseLeave: (e) => (e.currentTarget.style.color = "black"),
    })}
  onClick={() => {
    if (aso_to_bestart_aso_t_a !== "0") {
      handleStatusData2("yetToBeStartedAtAso");
    }
  }}
  onKeyDown={(e) => {
    if (e.key === "Enter" || e.key === " ") {
      if (aso_to_bestart_aso_t_a !== "0") {
        handleStatusData2("yetToBeStartedAtAso");
      }
    }
  }}
>
  {aso_to_bestart_aso_t_a === undefined ? "" : aso_to_bestart_aso_t_a || 0}
</span>

                      </b>
                    )}
                  </div>
                </div>
              </div>
            </Col>
            <Col
              xxl={2}
              xl={2}
              lg={2}
              md={6}
              sm={6}
              xs={6}
              className="mb-3"
            >
              <div className="sa-card sa-card1">
                <div className="d-flex justify-content-between">
                  <div className="head">
                    Not <span>Forwarded</span>
                  </div>
                  <div>
                    <img src="../images/not-forwarded.webp" alt="not forwarded"/>
                  </div>
                </div>
                <div className="d-flex">
                  <div className="w-100">
                    {(roleid === "2" || roleid === "10") && (
                      <b className="w-100">
                        <span
  role="button"
  tabIndex={0}
  style={{
    cursor:
      pending_at_aso === "0" || !pending_at_aso ? "default" : "pointer",
  }}
  {...(pending_at_aso !== "0" &&
    pending_at_aso && {
      onMouseEnter: (e) => (e.currentTarget.style.color = "blue"),
      onMouseLeave: (e) => (e.currentTarget.style.color = "black"),
    })}
  onClick={() => {
    if (pending_at_aso !== "0") {
      handleStatusData("pendinglistAtAso");
    }
  }}
  onKeyDown={(e) => {
    if (e.key === "Enter" || e.key === " ") {
      if (pending_at_aso !== "0") {
        handleStatusData("pendinglistAtAso");
      }
    }
  }}
>
  {pending_at_aso === undefined ? "" : pending_at_aso || 0}
</span>

                      </b>
                    )}
                    {roleid === "3" && (
                      <b className="w-100">
                        <span
  role="button"
  tabIndex={0}
  style={{
    cursor:
      aso_pending_at_aso === "0" || !aso_pending_at_aso
        ? "default"
        : "pointer",
  }}
  {...(aso_pending_at_aso !== "0" &&
    aso_pending_at_aso && {
      onMouseEnter: (e) => (e.currentTarget.style.color = "blue"),
      onMouseLeave: (e) => (e.currentTarget.style.color = "black"),
    })}
  onClick={() => {
    if (aso_pending_at_aso !== "0") {
      handleStatusData2("pendinglistAtAso");
    }
  }}
  onKeyDown={(e) => {
    if ((e.key === "Enter" || e.key === " ") && aso_pending_at_aso !== "0") {
      handleStatusData2("pendinglistAtAso");
    }
  }}
>
  {aso_pending_at_aso === undefined ? "" : aso_pending_at_aso || 0}
</span>

                      </b>
                    )}
                  </div>
                </div>
              </div>
            </Col>
            <Col
              xxl={2}
              xl={2}
              lg={2}
              md={6}
              sm={6}
              xs={6}
              className="mb-3"
            >
              <div className="sa-card sa-card2">
                <div className="d-flex justify-content-between">
                  <div className="head">
                    Pending @ <span>AD</span>
                  </div>
                  <div>
                    <img src="../images/pending.webp" alt="pending"/>
                  </div>
                </div>
                <div className="d-flex">
                  <div className="w-100">
                    {(roleid === "2" || roleid === "10") && (
                      <b className="w-100">
                        <span
  role="button"
  tabIndex={0}
  style={{
    cursor:
      pending_at_ad === "0" || !pending_at_ad ? "default" : "pointer",
  }}
  {...(pending_at_ad !== "0" &&
    pending_at_ad && {
      onMouseEnter: (e) => (e.currentTarget.style.color = "blue"),
      onMouseLeave: (e) => (e.currentTarget.style.color = "black"),
    })}
  onClick={() => {
    if (pending_at_ad !== "0") {
      handleStatusData("pendinglistAtAd");
    }
  }}
  onKeyDown={(e) => {
    if ((e.key === "Enter" || e.key === " ") && pending_at_ad !== "0") {
      handleStatusData("pendinglistAtAd");
    }
  }}
>
  {pending_at_ad === undefined ? "" : pending_at_ad || 0}
</span>

                      </b>
                    )}

                    {roleid === "3" && (
                      <b className="w-100">
                        {" "}
                        <span
  role="button"
  tabIndex={0}
  style={{
    cursor:
      aso_pending_at_ad === "0" || !aso_pending_at_ad
        ? "default"
        : "pointer",
  }}
  {...(aso_pending_at_ad !== "0" &&
    aso_pending_at_ad && {
      onMouseEnter: (e) => (e.currentTarget.style.color = "blue"),
      onMouseLeave: (e) => (e.currentTarget.style.color = "black"),
    })}
  onClick={() => {
    if (aso_pending_at_ad !== "0") {
      handleStatusData2("pendinglistAtAd");
    }
  }}
  onKeyDown={(e) => {
    if ((e.key === "Enter" || e.key === " ") && aso_pending_at_ad !== "0") {
      handleStatusData2("pendinglistAtAd");
    }
  }}
>
  {aso_pending_at_ad === undefined ? "" : aso_pending_at_ad || 0}
</span>

                      </b>
                    )}
                  </div>
                </div>
              </div>
            </Col>
            <Col
              xxl={2}
              xl={2}
              lg={2}
              md={6}
              sm={6}
              xs={6}
              className="mb-3"
            >
              <div className="sa-card sa-card2">
                <div className="d-flex justify-content-between">
                  <div className="head">
                    Pending @ <span>CPO</span>
                  </div>
                  <div>
                    <img src="../images/pending.webp" alt="pending"/>
                  </div>
                </div>
                <div className="d-flex">
                  <div className="w-100">
                    {(roleid === "2" || roleid === "10") && (
                      <b className="w-100">
                        <span
  role="button"
  tabIndex={0}
  style={{
    cursor:
      pending_at_cpo === "0" || !pending_at_cpo
        ? "default"
        : "pointer",
  }}
  {...(pending_at_cpo !== "0" &&
    pending_at_cpo && {
      onMouseEnter: (e) => (e.currentTarget.style.color = "blue"),
      onMouseLeave: (e) => (e.currentTarget.style.color = "black"),
    })}
  onClick={() => {
    if (pending_at_cpo !== "0") {
      handleStatusData("pendinglistAtCpo");
    }
  }}
  onKeyDown={(e) => {
    if ((e.key === "Enter" || e.key === " ") && pending_at_cpo !== "0") {
      handleStatusData("pendinglistAtCpo");
    }
  }}
>
  {pending_at_cpo === undefined ? "" : pending_at_cpo || 0}
</span>

                      </b>
                    )}

                    {roleid === "3" && (
                      <b className="w-100">
                        <span
  role="button"
  tabIndex={0}
  style={{
    cursor:
      aso_pending_at_cpo === "0" || !aso_pending_at_cpo
        ? "default"
        : "pointer",
  }}
  {...(aso_pending_at_cpo !== "0" &&
    aso_pending_at_cpo && {
      onMouseEnter: (e) => (e.currentTarget.style.color = "blue"),
      onMouseLeave: (e) => (e.currentTarget.style.color = "black"),
    })}
  onClick={() => {
    if (aso_pending_at_cpo !== "0") {
      handleStatusData2("pendinglistAtCpo");
    }
  }}
  onKeyDown={(e) => {
    if ((e.key === "Enter" || e.key === " ") && aso_pending_at_cpo !== "0") {
      handleStatusData2("pendinglistAtCpo");
    }
  }}
>
  {aso_pending_at_cpo === undefined ? "" : aso_pending_at_cpo || 0}
</span>

                      </b>
                    )}
                  </div>
                </div>
              </div>
            </Col>
            <Col
              xxl={2}
              xl={2}
              lg={2}
              md={6}
              sm={6}
              xs={6}
              className="mb-3"
            >
              <div className="sa-card sa-card3">
                <div className="d-flex justify-content-between">
                  <div className="head">
                    Approved <span>aa</span>
                  </div>
                  <div>
                    <img src="../images/approved.webp" alt="approved"/>
                  </div>
                </div>
                <div className="d-flex">
                  <div className="w-100">
                    {(roleid === "2" || roleid === "10") && (
                      <b className="w-100">
                        <span
  role="button"
  tabIndex={0}
  style={{
    cursor:
      approved === "0" || !approved
        ? "default"
        : "pointer",
  }}
  {...(approved !== "0" &&
    approved && {
      onMouseEnter: (e) => (e.currentTarget.style.color = "blue"),
      onMouseLeave: (e) => (e.currentTarget.style.color = "black"),
    })}
  onClick={() => {
    if (approved !== "0") {
      handleStatusData("approvedListAtAdOrCpo");
    }
  }}
  onKeyDown={(e) => {
    if ((e.key === "Enter" || e.key === " ") && approved !== "0") {
      handleStatusData("approvedListAtAdOrCpo");
    }
  }}
>
  {approved === undefined ? "" : approved || 0}{" "}
</span>

                      </b>
                    )}

                    {roleid === "3" && (
                      <b className="w-100">
                        <span
  role="button"
  tabIndex={0}
  style={{
    cursor:
      aso_approved === "0" || !aso_approved
        ? "default"
        : "pointer",
  }}
  {...(aso_approved !== "0" &&
    aso_approved && {
      onMouseEnter: (e) => (e.currentTarget.style.color = "blue"),
      onMouseLeave: (e) => (e.currentTarget.style.color = "black"),
    })}
  onClick={() => {
    if (aso_approved !== "0") {
      handleStatusData2("approvedListAtAso");
    }
  }}
  onKeyDown={(e) => {
    if ((e.key === "Enter" || e.key === " ") && aso_approved !== "0") {
      handleStatusData2("approvedListAtAso");
    }
  }}
>
  {aso_approved === undefined ? "" : aso_approved || 0}{" "}
</span>

                      </b>
                    )}
                  </div>
                </div>
              </div>
            </Col>
          </Row>
          {/*} */}

          <Row>
            <Col
              xxl={6}
              xl={6}
              lg={6}
              md={6}
              sm={12}
              xs={12}
              className="mb-3 list-left"
            >
              <div className="sa-list">
                <h4>Note :</h4>
                <ListGroup>
                  <ListGroup.Item>
                    Not Forwarded : The ASOs saved but not Forwarded
                  </ListGroup.Item>
                  <ListGroup.Item>
                    Pending At AD : Forwarded from ASOs but Pending at AD
                  </ListGroup.Item>
                  <ListGroup.Item>
                    Pending At CPO: Forwarded from ADs but Pending at CPO
                  </ListGroup.Item>
                  <ListGroup.Item>Approved : Approved By CPO</ListGroup.Item>
                </ListGroup>
              </div>
            </Col>

            <Col
              xxl={6}
              xl={6}
              lg={6}
              md={6}
              sm={12}
              xs={12}
              className="mb-3 list-right"
            >
              <div className="sa-message">
                <h3>Message Board</h3>
                <p>
                  As part of Viksit Bharat@2047 the Government of Andhra Pradesh
                  (GoAP) has set an ambitious target to transform the state into
                  a $2.4 trillion economy by 2047. This goal includes achieving
                  a per capita income of $43,000. To realize this vision, the
                  GoAP. is actively developing a comprehensive roadmap under the
                  “Swarnandhra@2047” initiative. This initiative aligns with the
                  broader national vision of “Viksit Bharat@2047,” which aims
                  for a developed India by 2047.{" "}
                </p>
              </div>
            </Col>
          </Row>

          <Modal
            className="newmodal"
            fade={false}
            size="lg"
            aria-labelledby="contained-modal-title-vcenter"
            centered
            show={addModal}
          >
            <Modal.Header
              style={{
                display: "flex",
                justifyContent: "space-between",
                alignItems: "center",
              }}
            >
              {totalmandals && (
                <Modal.Title
                  className="text-center"
                  style={{ margin: "0 auto", color: "black" }}
                >
                  {" "}
                  Total Mandals{" "}
                </Modal.Title>
              )}
              {tobestartdata && (
                <Modal.Title
                  className="text-center"
                  style={{ margin: "0 auto", color: "black" }}
                >
                  {" "}
                  Mandals Yet To Be Start
                </Modal.Title>
              )}
              {asotobestartdata && (
                <Modal.Title
                  className="text-center"
                  style={{ margin: "0 auto", color: "black" }}
                >
                  {" "}
                  Mandals Yet To Be Start
                </Modal.Title>
              )}
              {asodata && (
                <Modal.Title
                  className="text-center"
                  style={{ margin: "0 auto", color: "black" }}
                >
                  Mandals Not Forwarded{" "}
                </Modal.Title>
              )}
              {aso_asodata && (
                <Modal.Title
                  className="text-center"
                  style={{ margin: "0 auto", color: "black" }}
                >
                  Mandals Not Forwarded{" "}
                </Modal.Title>
              )}
              {addata && (
                <Modal.Title
                  className="text-center"
                  style={{ margin: "0 auto", color: "black" }}
                >
                  Mandals Pending At AD{" "}
                </Modal.Title>
              )}
              {aso_addata && (
                <Modal.Title
                  className="text-center"
                  style={{ margin: "0 auto", color: "black" }}
                >
                  Mandals Pending At AD{" "}
                </Modal.Title>
              )}
              {cpodata && (
                <Modal.Title
                  className="text-center"
                  style={{ margin: "0 auto", color: "black" }}
                >
                  Mandals Pending At CPO{" "}
                </Modal.Title>
              )}
              {aso_cpodata && (
                <Modal.Title
                  className="text-center"
                  style={{ margin: "0 auto", color: "black" }}
                >
                  Mandals Pending At CPO{" "}
                </Modal.Title>
              )}
              {Approvedata && (
                <Modal.Title
                  className="text-center"
                  style={{ margin: "0 auto", color: "black" }}
                >
                  Mandals Approved{" "}
                </Modal.Title>
              )}
              {aso_Approvedata && (
                <Modal.Title
                  className="text-center"
                  style={{ margin: "0 auto", color: "black" }}
                >
                  Mandals Approved{" "}
                </Modal.Title>
              )}
              <span
  role="button"
  tabIndex={0}
  onClick={handleClose}
  onKeyDown={(e) => {
    if (e.key === "Enter" || e.key === " ") {
      handleClose();
    }
  }}
  onMouseEnter={(e) => (e.currentTarget.style.color = "red")}
  onMouseLeave={(e) => (e.currentTarget.style.color = "black")}
  style={{ fontSize: "29px", cursor: "pointer", color: "black" }}
  aria-label="Close"
>
  &#215;
</span>

            </Modal.Header>
            <Modal.Body className="p-3">
              <div style={{ maxHeight: "400px", overflowY: "auto" }}>
                <table
                  bordered
                  hover
                  id="my-table"
                  className="custom-table table-responsive  table-striped table table-bordered"
                  style={{ tableLayout: "fixed" }}
                >
                  <thead style={{ position: "sticky", top: 0, zIndex: 2 }}>
                    <tr className="text-center">
                      <th
                    
                      >
                        Sl No.
                      </th>
                      <th
                      
                      >
                        Mandal name
                      </th>
                    </tr>
                  </thead>
                  <tbody>
                    {mandaldata &&
                      mandaldata?.map((mandal, index) => (
                        <tr key={mandal.mandal_code} className="text-left">
                          <td className="text-center">{index + 1}</td>
                          {(totalmandals ||
                            asodata ||
                            tobestartdata ||
                            aso_asodata ||
                            asotobestartdata) && (
                              <td className="text-left">{mandal.mandal_name}</td>
                            )}
                          {(addata ||
                            cpodata ||
                            Approvedata ||
                            aso_addata ||
                            aso_cpodata ||
                            aso_Approvedata) && (
                              <td className="text-left">
                                <Link
                                  style={{
                                    textDecoration: "underline",
                                    cursor: "pointer",
                                    textDecorationColor: "blue",
                                  }}
                                  onClick={() =>
                                    dataentrytargetdata(mandal.mandal_code)
                                  }
                                >
                                  {mandal.mandal_name}
                                </Link>
                              </td>
                            )}{" "}
                        </tr>
                      ))}{" "}
                  </tbody>
                </table>
              </div>
            </Modal.Body>
            <Modal.Footer>
              <button
                variant="primary"
                onClick={handleClose}
                className="cancel"
              >
                Close
              </button>
            </Modal.Footer>
          </Modal>

          <Modal
            className="newmodal"
            fade={false}
            size="xl"
            aria-labelledby="contained-modal-title-vcenter"
            centered
            show={addModal2}
          >
            <Modal.Header
              style={{
                display: "flex",
                justifyContent: "space-between",
                alignItems: "center",
              }}
            >
              {dataentry && (
                <Modal.Title
                  className="text-center"
                  style={{ margin: "0 auto", color: "black" }}
                >
                  Target and Achievements Details{" "}
                </Modal.Title>
              )}
              {gmdp && (
                <Modal.Title
                  className="text-center"
                  style={{ margin: "0 auto", color: "black" }}
                >
                  Gross Mandal Domestic Product Details{" "}
                </Modal.Title>
              )}

<span
  role="button"
  tabIndex={0}
  onClick={handleClose2}
  onKeyDown={(e) => {
    if (e.key === 'Enter' || e.key === ' ') {
      handleClose2();
    }
  }}
  onMouseEnter={(e) => (e.currentTarget.style.color = 'red')}
  onMouseLeave={(e) => (e.currentTarget.style.color = 'black')}
  style={{ fontSize: '29px', cursor: 'pointer', color: 'black' }}
  aria-label="Close"
>
  &#215;
</span>

            </Modal.Header>
            <Modal.Body>
              <div className="tabs-top">
                <Nav variant="pills" className="flex-column">
                  <Row className="tabs-row">
                    <Col
                      xxl={3}
                      xl={3}
                      lg={3}
                      md={3}
                      sm={12}
                      xs={12}
                      className="px-0"
                    >
                      <Nav.Item className="tab-boxes tab-boxes1">
                        <Nav.Link
                          onClick={() => {
                            setgmdp(false);
                            setdataentry(true);
                          }}
                          eventKey="one"
                        >
                          <p>
                            Targets & Achievements<br></br>Entry
                          </p>
                        </Nav.Link>
                      </Nav.Item>
                    </Col>
                    <Col
                      xxl={3}
                      xl={3}
                      lg={3}
                      md={3}
                      sm={12}
                      xs={12}
                      className="px-0"
                    >
                      <Nav.Item className="tab-boxes tab-boxes2">
                        <Nav.Link
                          onClick={() => {
                            setdataentry(false);
                            setgmdp(true);
                          }}
                          eventKey="two"
                        >
                          <p>Gross Mandal Domestic Product Entry</p>
                        </Nav.Link>
                      </Nav.Item>
                    </Col>
                  </Row>
                </Nav>
              </div>

              <Row style={{ marginTop: "20px" }}>
                <div eventKey="one">
                  {dataentry && (
                    <div className="indicators-info">
                      <div className="activity-box d-flex mt-2">
                        <table
                          bordered
                          hover
                          id="my-table"
                          className="custom-table table-responsive  table-striped table table-bordered"
                        >
                          <thead
                            style={{ position: "sticky", top: 0, zIndex: 2 }}
                          >
                            <tr className="text-center">
                              <th
                              
                                colSpan={11}
                              >
                                Target and Achievements Details{" "}
                              </th>
                            </tr>
                            <tr className="text-center">
                              <th
                                rowSpan={2}
                              >
                                Sl No.
                              </th>
                              <th
                                rowSpan={2}
                              >
                                SECTOR
                              </th>
                              <th
                                rowSpan={2}
                              >
                                INDICATOR
                              </th>
                              <th
                                rowSpan={2}
                              >
                                UNIT
                              </th>
                              <th
                                colSpan={1}
                              >
                                ACHIEVEMENTS
                              </th>
                              <th
                                colSpan={5}
                              >
                                TARGETS
                              </th>
                              <th
                                
                                rowSpan={2}
                              >
                                Indicative Financial <br />
                                Plan-Expected sources <br /> of funding
                              </th>
                            </tr>
                            <tr>
                              <th>
                                2023-24
                              </th>
                              <th>
                                2024-25
                              </th>
                              <th>
                                2025-26
                              </th>
                              <th>
                                2026-27
                              </th>
                              <th>
                                2027-28
                              </th>
                              <th>
                                2028-29
                              </th>
                            </tr>
                          </thead>
                          <tbody>
                            {data &&
                              data?.map((indicator, index) => {
                                const showIndicatorName =
                                  index === 0 ||
                                  data[index - 1]?.indicator_name !==
                                  indicator.indicator_name;
                                return (
                                  <tr key={index} className="text-center">
                                    <td className="text-center">{index + 1}</td>
                                    <td
                                      className="text-left"
                                      style={{
                                        backgroundColor: showIndicatorName
                                          ? "#FCDC94"
                                          : null,
                                      }}
                                    >
                                      {showIndicatorName
                                        ? indicator.indicator_name
                                        : ""}
                                    </td>
                                    <td
                                      className="text-left"
                                      style={{
                                        backgroundColor: showIndicatorName
                                          ? "#FCDC94"
                                          : null,
                                      }}
                                    >
                                      {indicator.sub_indicator_name}
                                    </td>
                                    <td
                                      className="text-center"
                                      style={{
                                        backgroundColor: showIndicatorName
                                          ? "#FCDC94"
                                          : null,
                                      }}
                                    >
                                      {indicator.unit}
                                    </td>
                                    <td
                                      className="text-right"
                                      style={{
                                        backgroundColor: showIndicatorName
                                          ? "#FCDC94"
                                          : null,
                                      }}
                                    >
                                      {indicator.achived}
                                    </td>
                                    <td
                                      className="text-right"
                                      style={{
                                        backgroundColor: showIndicatorName
                                          ? "#FCDC94"
                                          : null,
                                      }}
                                    >
                                      {indicator.target_2024_2025}
                                    </td>
                                    <td
                                      className="text-right"
                                      style={{
                                        backgroundColor: showIndicatorName
                                          ? "#FCDC94"
                                          : null,
                                      }}
                                    >
                                      {indicator.target_2025_2026}
                                    </td>
                                    <td
                                      className="text-right"
                                      style={{
                                        backgroundColor: showIndicatorName
                                          ? "#FCDC94"
                                          : null,
                                      }}
                                    >
                                      {indicator.target_2026_2027}
                                    </td>
                                    <td
                                      className="text-right"
                                      style={{
                                        backgroundColor: showIndicatorName
                                          ? "#FCDC94"
                                          : null,
                                      }}
                                    >
                                      {indicator.target_2027_2028}
                                    </td>
                                    <td
                                      className="text-right"
                                      style={{
                                        backgroundColor: showIndicatorName
                                          ? "#FCDC94"
                                          : null,
                                      }}
                                    >
                                      {indicator.target_2028_2029}
                                    </td>
                                    <td
                                      className="text-center"
                                      style={{
                                        backgroundColor: showIndicatorName
                                          ? "#FCDC94"
                                          : null,
                                      }}
                                    >
                                      {indicator.source_of_funding}
                                    </td>
                                  </tr>
                                );
                              })}
                          </tbody>
                        </table>
                      </div>
                    </div>
                  )}
                </div>
                <div eventKey="two">
                  {gmdp && (
                    <div className="indicators-info">
                      <div className="activity-box d-flex mt-2">
                        <table
                          bordered
                          hover
                          id="my-table"
                          className="custom-table table-responsive  table-striped table table-bordered"
                        >
                          <thead
                            style={{ position: "sticky", top: 0, zIndex: 2 }}
                          >
                            <tr className="text-center">
                              <th
                                
                                colSpan={11}
                              >
                                Gross Mandal Domestic Product Details
                              </th>
                            </tr>

                            <tr className="text-center">
                              <th
                              
                                rowSpan={2}
                              >
                                Sl No.
                              </th>
                              <th
                              
                                rowSpan={2}
                              >
                                SECTOR
                              </th>
                              <th
                              
                                rowSpan={2}
                              >
                                INDUSTRY
                              </th>
                              <th
                               
                                colSpan={2}
                              >
                                2022-23
                              </th>
                            </tr>
                            <tr>
                              <th>
                                GVA <br />
                                (Rs. In Lakhs)
                              </th>
                              <th>
                                Contribution (%)
                              </th>
                            </tr>
                          </thead>

                          <tbody>
                            {data1 &&
                              data1?.map((indicator, index) => {
                                const showSectorName =
                                  index === 0 ||
                                  data1[index - 1]?.sector_name !==
                                  indicator.sector_name;
                                return (
                                  <tr key={index} className="text-center">
                                    <td className="text-center">{index + 1}</td>
                                    <td className="text-left">
                                      {showSectorName
                                        ? indicator.sector_name
                                        : ""}
                                    </td>
                                    <td className="text-left">
                                      {indicator.industry_name}
                                    </td>
                                    <td className="text-right">
                                      {indicator.gmdp}
                                    </td>
                                    <td className="text-right">
                                      {indicator.contribution}
                                    </td>
                                  </tr>
                                );
                              })}
                          </tbody>
                        </table>
                      </div>
                    </div>
                  )}
                </div>
              </Row>
            </Modal.Body>
            <Modal.Footer>
              <button
                variant="primary"
                onClick={handleClose2}
                className="cancel"
              >
                Close
              </button>
            </Modal.Footer>
          </Modal>
        </Container>
        ):
        <Container fluid className="outer-page-content-container "></Container>}
    </>
  );
}
